<div *ngIf="data" class="assign-panel card p-4">
  <form (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="d-flex align-items-center gap-3 mb-4 mt-3">
      <div
        class="circle-icon-primary bg-primary-subtle text-primary d-flex align-items-center justify-content-center rounded-circle"
        style="width: 40px; height: 40px;">
        <i class="ri-calendar-line fs-5"></i>
      </div>
      <div class="flex-grow-1">
        <h5 class="fw-semibold mt-4">{{ data?.documentNumber1 }}</h5>
        <div class="text-muted ">{{ data?.account }}</div>
      </div>
      <h5
        [ngClass]="{
          'text-primary': data?.debitCredit === 'C',
          'text-danger': data?.debitCredit === 'D'
        }"
        class="fw-bold m-0">
        {{ data?.amount | currency: data?.currency }}
      </h5>
    </div>

    <div class="mb-3">
      <div class="d-flex justify-content-between fw-semibold">
        <span>{{ data?.contraAccount }}</span>
        <span>{{ data?.bookingDate | date: 'dd-MM-yyyy' }}</span>
      </div>
      <div class="text-muted">
        {{ 'BOOKINGS.COST_CENTERS' | translate }}:
        <span class="fw-semibold">{{ data?.costCenter1 }}</span>
        <span *ngIf="data?.costCenter2"> / {{ data?.costCenter2 }}</span>
      </div>
    </div>


    <div class="text-muted mb-3">
      {{ 'BOOKINGS.DESCRIPTION' | translate }}: {{ data?.description }}
    </div>

    <div class="d-flex align-items-center mb-4">
      <div class=" text-muted">
        {{ 'APARTMENT.TYPE' | translate }}:
        <span
          [ngClass]="{
            'bg-danger-subtle text-danger': data?.debitCredit === 'D',
            'bg-primary-subtle text-primary': data?.debitCredit === 'C'
          }"
          class="fw-semibold px-2 py-1 rounded-2 ms-2 d-inline-block"
        >
          {{ (data?.debitCredit === 'D' ? 'TRANSACTION.DEBIT' : 'TRANSACTION.CREDIT')|translate }}
        </span>
      </div>
    </div>

    <div class="mb-4">
      <autocomplete
        (onSelect)="getDocumentData($event)"
        [clearable]="true"
        [placeholder]="'MAIN.DOCUMENTS' | translate"
        [url]="documentsService.getAll.bind(documentsService)"
        bindLabel="designation"
        formControlName="documentId"
        label="MAIN.DOCUMENTS"
      />
    </div>

    <div *ngIf="document" class="bg-primary-subtle p-3 rounded text-muted mb-3">
      <div class="mb-1">
        {{ 'DASHBOARD.DATE' | translate }}:
        <span class="fw-semibold">
          {{ document?.fromDate | date: 'dd. MMMM yyyy' }}</span> –
        <span> {{ document?.toDate | date: 'dd. MMMM yyyy' }}
        </span>
      </div>
      <div class="mb-1">
        {{ 'CITY.NAME' | translate }}:
        <span class="fw-semibold">{{ document?.designation }}</span>
      </div>
      <div>
        {{ 'PAYMENT.RENTER' | translate }}:
        <span class="fw-semibold">{{ document?.renter|fullName }}</span>
      </div>
    </div>

    <div class="d-flex justify-content-end mt-2">
      @if (initialDocument?.document && !document) {
        <p-button
          [disabled]="isPending()"
          [label]="'ACTIONS.DELETE' | translate"
          [loading]="isPending()"
          styleClass="btn btn-danger"
          type="submit"
        />
      } @else if (initialDocument?.document && document && initialDocument?.documentId !== document.id) {
        <p-button
          [disabled]="isPending()"
          [label]="'RESIDENTS.REASSIGN' | translate"
          [loading]="isPending()"
          styleClass="btn btn-primary"
          type="submit"
        />
      } @else {
        <p-button
          [disabled]="isPending()"
          [label]="'RESIDENTS.ASSIGN' | translate"
          [loading]="isPending()"
          styleClass="btn btn-primary"
          type="submit"
        />
      }
      <button
        (click)="cancel()"
        class="btn btn-soft-primary ms-2"
        type="button"
      >
        {{ 'CANCEL'|translate }}
      </button>
    </div>
  </form>
</div>
